/* ==========================================================================
   Switch Fashion — Mobile PDP (Redesign 08/2026)
   Eigenständig: nutzt nur window.theme.routes + Shopify AJAX API.
   ========================================================================== */
(function () {
  'use strict';

  var ROUTES = (window.theme && window.theme.routes) || {};
  var CART_GET = (ROUTES.cart || '/cart') + '.js';

  /* Beträge müssen exakt so aussehen wie die serverseitig gerenderten
     (money-Filter). Intl würde "59,90 €" liefern, der Shop schreibt "€59,90"
     — deshalb das Shop-Format anwenden statt zu raten. */
  var fmt = { locale: 'de', currency: 'EUR', shopCurrency: 'EUR', format: '€{{amount_with_comma_separator}}' };

  function group(cents, precision, thousands, decimal) {
    var n = (cents / 100).toFixed(precision).split('.');
    var whole = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return n[1] ? whole + decimal + n[1] : whole;
  }

  function money(cents) {
    /* Fremdwährung (Markets): Shop-Format passt nicht, Intl ist dann korrekter. */
    if (fmt.currency !== fmt.shopCurrency) {
      return (cents / 100).toLocaleString(fmt.locale, {
        style: 'currency', currency: fmt.currency, minimumFractionDigits: 2
      });
    }
    return fmt.format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
        default: return group(cents, 2, '.', ',');
      }
    });
  }

  /* Sanftes Scrollen läuft nicht überall — im Hintergrundtab pausiert es, und
     wer Bewegung reduziert haben will, soll es gar nicht bekommen. In beiden
     Fällen springt die Galerie einfach direkt. */
  function scrollX(el, left) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      el.scrollTo({ left: left, behavior: reduce || document.hidden ? 'auto' : 'smooth' });
    } catch (e) {
      el.scrollLeft = left;
    }
    /* Wenn nach dem Aufruf nichts passiert ist, hart setzen. */
    if (Math.abs(el.scrollLeft - left) > 2 && (reduce || document.hidden)) el.scrollLeft = left;
  }

  /* Nächster Liefertag: Bestellungen vor Cutoff gehen am selben Werktag raus,
     danach am nächsten. Plus Transit in Werktagen — Wochenende zählt nicht. */
  function deliveryDate(cutoffHour, transitDays) {
    var d = new Date();
    if (d.getHours() >= cutoffHour) d.setDate(d.getDate() + 1);
    var added = 0;
    while (added < transitDays) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  customElements.define('sf-pdp', class extends HTMLElement {
    connectedCallback() {
      this.cfg = JSON.parse(this.querySelector('[data-sf-config]').textContent);
      if (this.cfg.currency) fmt.currency = this.cfg.currency;
      if (this.cfg.locale) fmt.locale = this.cfg.locale;
      if (this.cfg.shopCurrency) fmt.shopCurrency = this.cfg.shopCurrency;
      if (this.cfg.moneyFormat) fmt.format = this.cfg.moneyFormat;
      this.variants = this.cfg.variants;
      this.colorIndex = typeof this.cfg.colorIndex === 'number' ? this.cfg.colorIndex : -1;
      this.sizeIndex = typeof this.cfg.sizeIndex === 'number' ? this.cfg.sizeIndex : -1;
      this.threshold = this.cfg.threshold;      // in Cent
      this.shipCost = this.cfg.shipCost;        // in Cent
      this.cartTotal = this.cfg.cartTotal;      // in Cent, serverseitig gerendert
      this.current = this.variants.filter(function (v) { return v.id === this.cfg.initialVariantId; }, this)[0] || this.variants[0];

      this.initGallery();
      this.initOptions();
      this.initDisclosures();
      this.initSticky();
      this.initCart();
      this.initDelivery();
      this.renderThreshold();
      this.refreshCart();   // echter Warenkorbstand, unabhängig vom Seiten-Cache
      this.watchCart();
    }

    /* Das Theme meldet jede Warenkorbaenderung selbst: <product-form> beim
       Hinzufuegen, <cart-form> beim Aendern der Menge im Drawer. Mehr braucht
       es nicht — kein Eingriff in window.fetch. */
    watchCart() {
      var self = this;
      ['on:cart:add', 'on:cart:change', 'on:cart:error'].forEach(function (ev) {
        document.addEventListener(ev, function () { self.refreshCart(); });
      });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) self.refreshCart();
      });
      /* Ruecksprung aus dem bfcache liefert eine eingefrorene Seite. */
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refreshCart(); });
    }

    /* ---------------- Galerie ---------------- */
    initGallery() {
      var track = this.querySelector('[data-sf-gal]');
      if (!track) return;
      this.galTrack = track;
      var thumbs = this.querySelectorAll('[data-sf-thumb]');
      var count = this.querySelector('[data-sf-galcount]');
      var total = track.children.length;
      var self = this;

      /* Lädt die Bilder rund um die aktuelle Position vor. Der Browser holt
         sie über denselben srcset-Kandidaten, den auch das <img> nähme —
         beim Wischen liegen sie dann schon im Cache. */
      this.warmAround = function (i) {
        var slides = track.children;
        for (var n = i - 1; n <= i + 2; n++) {
          if (n < 0 || n >= slides.length) continue;
          var img = slides[n].querySelector('img');
          if (!img || img.dataset.sfWarm) continue;
          img.dataset.sfWarm = '1';
          img.loading = 'eager';
          try {
            var warm = new Image();
            if (img.sizes) warm.sizes = img.sizes;
            if (img.srcset) warm.srcset = img.srcset;
            warm.src = img.currentSrc || img.src;
          } catch (e) { /* Vorladen ist Kür, kein Muss */ }
        }
      };
      this.warmAround(0);

      var onScroll = function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i === self._gi) return;
        self._gi = i;
        self.warmAround(i);
        thumbs.forEach(function (t, n) {
          var aktiv = n === i;
          t.setAttribute('aria-selected', aktiv ? 'true' : 'false');
          /* Das aktive Miniaturbild soll sichtbar bleiben, ohne die Seite zu scrollen. */
          if (aktiv && t.parentElement) {
            var p = t.parentElement, l = t.offsetLeft - p.offsetLeft;
            if (l < p.scrollLeft || l + t.offsetWidth > p.scrollLeft + p.clientWidth) {
              scrollX(p, l - 16);
            }
          }
        });
        if (count) count.textContent = (i + 1) + '/' + total;
      };
      track.addEventListener('scroll', onScroll, { passive: true });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.dataset.sfThumb, 10);
          scrollX(track, i * track.clientWidth);
        });
      });
    }

    scrollGalleryTo(mediaId) {
      if (!this.galTrack || !mediaId) return;
      var slide = this.galTrack.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      scrollX(this.galTrack, slide.offsetLeft - this.galTrack.offsetLeft);
      if (this.warmAround) {
        this.warmAround(Array.prototype.indexOf.call(this.galTrack.children, slide));
      }
    }

    /* ---------------- Varianten ---------------- */
    initOptions() {
      var self = this;
      this.querySelectorAll('[data-sf-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.dataset.sfOptIndex, 10);
          var val = btn.dataset.sfOptValue;
          var picked = self.current.options.slice();
          picked[idx] = val;
          self.select(picked, idx);
        });
      });
    }

    select(picked, changedIdx) {
      var match = this.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === picked[i]; });
      })[0];

      /* Kombination existiert nicht (z. B. Farbe ohne diese Größe):
         Größe zurücksetzen auf die erste verfügbare dieser Farbe. */
      if (!match) {
        match = this.variants.filter(function (v) {
          return v.options[changedIdx] === picked[changedIdx] && v.available;
        })[0] || this.variants.filter(function (v) {
          return v.options[changedIdx] === picked[changedIdx];
        })[0];
      }
      if (!match) return;

      this.current = match;
      this.renderVariant();
      this.scrollGalleryTo(match.featured_media_id);

      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    renderVariant() {
      var v = this.current;

      this.querySelectorAll('[data-sf-opt]').forEach(function (btn) {
        var i = parseInt(btn.dataset.sfOptIndex, 10);
        btn.setAttribute('aria-pressed', v.options[i] === btn.dataset.sfOptValue ? 'true' : 'false');
      });

      this.querySelectorAll('[data-sf-variant-id]').forEach(function (el) { el.value = v.id; });

      this.querySelectorAll('[data-sf-price]').forEach(function (el) { el.textContent = money(v.price); });
      var was = this.querySelector('[data-sf-compare]');
      if (was) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        was.textContent = onSale ? money(v.compare_at_price) : '';
        was.hidden = !onSale;
      }

      var optLabel = this.querySelector('[data-sf-optname]');
      if (optLabel && this.colorIndex >= 0) optLabel.textContent = v.options[this.colorIndex];

      var stickySize = this.querySelector('[data-sf-sticky-size]');
      if (stickySize && this.sizeIndex >= 0) stickySize.textContent = v.options[this.sizeIndex];

      /* Knappheit nur zeigen, wenn die Zahl echt und niedrig ist. */
      var scarce = this.querySelector('[data-sf-scarcity]');
      if (scarce) {
        var q = v.inventory_quantity;
        var show = v.available && typeof q === 'number' && q > 0 && q <= this.cfg.scarcityAt;
        scarce.hidden = !show;
        if (show) {
          scarce.textContent = this.colorIndex >= 0
            ? 'Nur noch ' + q + ' in ' + v.options[this.colorIndex]
            : 'Nur noch ' + q + ' verfügbar';
        }
      }

      var stock = this.querySelector('[data-sf-stock]');
      if (stock) {
        stock.textContent = v.available
          ? (this.cfg.inStockLabel || 'Auf Lager')
          : (this.cfg.soldOutLabel || 'Ausverkauft');
      }
      var dot = this.querySelector('[data-sf-stockdot]');
      if (dot) {
        dot.classList.toggle('sf-dot--warn', !v.available);
        /* Der Puls signalisiert Verfügbarkeit — bei ausverkauft muss er weg. */
        dot.classList.toggle('sf-dot--pulse', v.available);
      }
      var deliverRow = this.querySelector('[data-sf-deliverrow]');
      if (deliverRow) deliverRow.hidden = !v.available;

      /* Abholung: Verfügbarkeit je Variante, direkt aus Shopify vorgerendert. */
      var puRow = this.querySelector('[data-sf-pickup-row]');
      if (puRow) {
        puRow.hidden = !v.pickup;
        if (v.pickup) {
          var puText = puRow.querySelector('[data-sf-pickup-text]');
          /* Vorlage stammt aus den Theme-Locales, der Name aus Shopify. */
          if (puText && this.cfg.pickupTemplate) {
            puText.innerHTML = this.cfg.pickupTemplate.replace(
              '__LOC__', String(v.pickupName).replace(/[<>&]/g, ''));
          }
          var puTime = puRow.querySelector('[data-sf-pickup-time]');
          if (puTime) puTime.textContent = v.pickupTime ? '— ' + v.pickupTime : '';
        }
      }

      var self = this;
      this.kaufKnoepfe();

      this.announce(v);
      this.renderThreshold();
    }

    /* Screenreader bekommen den Wechsel sonst nicht mit — die Werte ändern
       sich still im DOM. Eine gebündelte Ansage statt vier Live-Regionen. */
    announce(v) {
      var box = this.querySelector('[data-sf-announce]');
      if (!box) return;
      var teile = [v.options.join(', '), money(v.price)];
      teile.push(v.available
        ? (this.cfg.inStockLabel || 'Auf Lager')
        : (this.cfg.soldOutLabel || 'Ausverkauft'));
      box.textContent = teile.join(' · ');
    }

    /* ---------------- Aufklapper ---------------- */
    initDisclosures() {
      this.querySelectorAll('[data-sf-toggle]').forEach(function (head) {
        var body = document.getElementById(head.getAttribute('aria-controls'));
        head.addEventListener('click', function () {
          var open = head.getAttribute('aria-expanded') === 'true';
          head.setAttribute('aria-expanded', String(!open));
          if (body) body.hidden = open;
          var sign = head.querySelector('.sf-acc__sign');
          if (sign) sign.textContent = open ? '+' : '–';
        });
      });

      var self = this;
      this.querySelectorAll('[data-sf-sheet-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dlg = self.querySelector('#' + btn.dataset.sfSheetOpen);
          if (dlg) dlg.showModal();
        });
      });
      this.querySelectorAll('[data-sf-sheet-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { btn.closest('dialog').close(); });
      });
      /* Klick auf den Backdrop schließt — das Panel selbst nicht. */
      this.querySelectorAll('dialog.sf-sheet').forEach(function (dlg) {
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      });
    }

    /* ---------------- Sticky-Leiste ---------------- */
    initSticky() {
      var bar = this.querySelector('[data-sf-sticky]');
      var anchor = this.querySelector('[data-sf-atc-anchor]');
      if (!bar || !anchor || !('IntersectionObserver' in window)) return;
      /* Leiste erscheint genau dann, wenn der Inline-Button nicht sichtbar ist —
         darüber wie darunter. */
      new IntersectionObserver(function (entries) {
        bar.dataset.shown = entries[0].isIntersecting ? 'false' : 'true';
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' }).observe(anchor);
    }

    /* ---------------- Lieferdatum ---------------- */
    initDelivery() {
      var el = this.querySelector('[data-sf-delivery]');
      if (!el) return;
      el.textContent = deliveryDate(this.cfg.cutoffHour, this.cfg.transitDays);
      var row = this.querySelector('[data-sf-deliverrow]');
      if (row && this.current && this.current.available) row.hidden = false;
    }

    /* ---------------- Kaufknoepfe ---------------- */
    /* Ist die Variante weg, stellt die Benachrichtigungs-App im Formular eine
       echte Handlung bereit. Ein deaktivierter Button darueber waere eine tote
       Flaeche an der wichtigsten Stelle.

       Die App fuegt ihren Button aber erst rund 700 ms nach dem Variantenwechsel
       ein — also nach diesem Code. Ohne den Beobachter unten bliebe der tote
       Button stehen und beide waeren gleichzeitig sichtbar. */
    kaufKnoepfe() {
      var v = this.current;
      if (!v) return;
      var self = this;
      var melden = document.querySelector('.restock-alerts-notify-button');
      this.querySelectorAll('[data-sf-atc]').forEach(function (b) {
        var inLeiste = b.hasAttribute('data-sf-atc-plain');
        if (!v.available) {
          if (inLeiste) {
            b.hidden = false;
            b.disabled = !melden;
            b.dataset.sfNotify = melden ? '1' : '';
            b.textContent = melden
              ? (melden.textContent.replace(/\s+/g, ' ').trim() || 'Wieder verfügbar?')
              : (self.cfg.soldOutLabel || 'Ausverkauft');
          } else {
            b.hidden = !!melden;
            b.disabled = true;
            b.textContent = self.cfg.soldOutLabel || 'Ausverkauft';
          }
          return;
        }
        b.hidden = false;
        b.disabled = false;
        delete b.dataset.sfNotify;
        /* Die Sticky-Leiste zeigt den Preis links — im Button waere er doppelt. */
        b.textContent = inLeiste ? self.cfg.atcLabel : self.cfg.atcLabel + ' · ' + money(v.price);
      });
      /* Bewusst NICHT: den Button der App per display steuern. Der Versuch hat
         den Ausverkauft-Fall zerschossen — die App zeigt ihn ueber eigene
         Logik, ein Inline-display gewinnt dagegen dauerhaft. Ein sichtbarer
         "Wieder verfuegbar?"-Button neben einer lieferbaren Variante ist
         kosmetisch; ein fehlender im Ausverkauft-Fall kostet die Anmeldung. */
      if (!v.available && !melden) this.wartetAufMelden();
    }

    wartetAufMelden() {
      if (this._meldeBeobachter || !('MutationObserver' in window)) return;
      var ziel = this.querySelector('[data-sf-atc-anchor]');
      if (!ziel) return;
      var self = this;
      this._meldeBeobachter = new MutationObserver(function () {
        if (!document.querySelector('.restock-alerts-notify-button')) return;
        self._meldeBeobachter.disconnect();
        self._meldeBeobachter = null;
        self.kaufKnoepfe();
      });
      this._meldeBeobachter.observe(ziel, { childList: true, subtree: true });
      /* Notbremse: kommt die App nie, bleibt der deaktivierte Button stehen —
         das ist der ehrliche Rueckfall, kein Fehlerzustand. */
      setTimeout(function () {
        if (self._meldeBeobachter) { self._meldeBeobachter.disconnect(); self._meldeBeobachter = null; }
      }, 8000);
    }

    /* ---------------- Versandschwelle ---------------- */
    renderThreshold() {
      var box = this.querySelector('[data-sf-thresh]');
      if (!box) return;
      /* Liegt schon etwas im Korb, gilt dessen echter Wert. Ist er leer,
         rechnen wir die aktuelle Auswahl als Vorschau. Beides zu addieren
         würde den Artikel doppelt zählen, sobald er hinzugefügt wurde. */
      var basis = this.basisValue();
      var remaining = Math.max(0, this.threshold - basis);
      var free = remaining === 0;

      box.classList.toggle('sf-thresh--free', free);
      /* Leerer Warenkorb zeigt eine Vorschau auf die Auswahl. Ohne eigene
         Formulierung steht bei leerem und gefülltem Korb dieselbe Zahl —
         man sieht dann nicht, ob die eigene Aktion angekommen ist. */
      var vorschau = this.cartTotal === 0;
      /* Der Zusatz haengt am Warenkorb, nicht an der Variante: Sobald etwas
         drin liegt, ist die Zahl oben keine Vorschau mehr. */
      var cond = box.querySelector('[data-sf-thresh-cond]');
      if (cond) cond.hidden = !vorschau;
      var labelText = free
        ? 'Gratisversand erreicht'
        : 'Noch ' + money(remaining) + ' bis zum Gratisversand';
      this.querySelectorAll('[data-sf-thresh-label]').forEach(function (el) { el.textContent = labelText; });
      var right = box.querySelector('[data-sf-thresh-cost]');
      if (right) right.textContent = free ? 'Versand aktuell gratis' : 'Versand aktuell ' + money(this.shipCost);
      var pct = Math.min(100, (basis / this.threshold) * 100);
      var fill = box.querySelector('[data-sf-thresh-fill]');
      if (fill) fill.style.width = pct + '%';

      var stickyFill = this.querySelector('[data-sf-sticky-fill]');
      if (stickyFill) {
        stickyFill.style.width = pct + '%';
        var wrap = this.querySelector('[data-sf-sticky-progress]');
        if (wrap) wrap.classList.toggle('sf-sticky__progress--free', free);
      }
      var hint = box.querySelector('[data-sf-thresh-hint]');
      if (hint) hint.textContent = free ? this.cfg.hintFree : this.cfg.noteGap;

      /* Sticky-Leiste zeigt den Versand, der für diese Auswahl tatsächlich anfällt. */
      var stickyShip = this.querySelector('[data-sf-sticky-ship]');
      if (stickyShip && this.current && !this.current.available) {
        /* Versandkosten fuer etwas, das nicht lieferbar ist, sind nur Laerm. */
        stickyShip.textContent = '';
      } else if (stickyShip) {
        stickyShip.textContent = free
          ? (this.cfg.shipLabelFree || 'Gratis Versand')
          : (this.cfg.shipLabelPaid || 'zzgl. [betrag] Versand').replace('[betrag]', money(this.shipCost));
        stickyShip.classList.toggle('sf-sticky__meta--free', free);
      }

      this.renderCrossHints(remaining);
    }

    basisValue() {
      return this.cartTotal > 0 ? this.cartTotal : (this.current ? this.current.price : 0);
    }

    renderCrossHints(remaining) {
      var self = this;
      var basis = this.basisValue();
      this.querySelectorAll('[data-sf-cross-card]').forEach(function (card) {
        var price = parseInt(card.dataset.sfCrossPrice, 10);
        var hint = card.querySelector('[data-sf-cross-hint]');
        if (!hint) return;
        var closes = basis + price >= self.threshold;
        hint.textContent = closes
          ? 'zusammen ' + money(basis + price) + ' · Gratis Versand'
          : 'zusammen ' + money(basis + price) + ' · noch ' + money(self.threshold - basis - price);
        hint.classList.toggle('sf-cross__hint--free', closes);
      });
      /* Das günstigste Teil, das die Lücke wirklich schließt, nach vorn. */
      var list = this.querySelector('[data-sf-cross-list]');
      if (!list || remaining === 0) return;
      var cards = Array.prototype.slice.call(list.children);
      var filler = cards
        .filter(function (c) { return parseInt(c.dataset.sfCrossPrice, 10) >= remaining; })
        .sort(function (a, b) { return a.dataset.sfCrossPrice - b.dataset.sfCrossPrice; })[0];
      if (filler && filler !== list.firstElementChild) list.insertBefore(filler, list.firstElementChild);
    }

    /* ---------------- Warenkorb ---------------- */
    initCart() {
      var self = this;
      var form = this.querySelector('.js-product-form');

      /* Der Button im Formular gehört dem Theme: <product-form> fängt submit
         ab, rendert Header und Drawer neu und öffnet ihn. Kein eigener Klick-
         Handler — sonst schreiben zwei Stellen in denselben Warenkorb. */
      this.querySelectorAll('[data-sf-atc]').forEach(function (btn) {
        if (btn.type === 'submit') return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          /* Ausverkauft: nicht in den Warenkorb, sondern zur Benachrichtigung. */
          if (btn.dataset.sfNotify === '1') {
            var melden = document.querySelector('.restock-alerts-notify-button');
            if (melden) {
              melden.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
          }
          /* Sticky-Leiste löst dasselbe Formular aus. */
          if (form && form.requestSubmit) form.requestSubmit();
          else if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
      });

      /* Das Theme meldet jede Änderung — daran hängt die Versandrechnung. */
      ['on:cart:add', 'on:cart:change', 'on:cart:error'].forEach(function (ev) {
        document.addEventListener(ev, function () { self.refreshCart(); });
      });
    }



    refreshCart() {
      var self = this;
      return fetch(CART_GET, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.currency) fmt.currency = cart.currency;
          self.cartTotal = cart.total_price;
          self.cartCount = cart.item_count;
          self.renderThreshold();
          /* Den Zähler im Header rendert das Theme selbst neu. Eigenes
             Schreiben hier hat ihn bei veraltetem Stand überschrieben. */
          return cart;
        })
        .catch(function () { /* Warenkorb nicht erreichbar — Seite bleibt bedienbar */ });
    }
  });
})();
